import { css } from '@emotion/react';

export const regularTextStyle = css`
    font-family: RobotoMono;
    font-size: 20px;
`;

export const regularLightTextStyle = css`
    font-family: RobotoMono;
    font-weight: lighter;
    font-size: 20px;
`;

export const smallRegularLightTextStyle = css`
    font-family: RobotoMono;
    font-weight: lighter;
    font-szie: 12px;
`;